import { useSyncExternalStore } from "react";
import { getCmsPreviewToken, subscribeCmsPreviewToken } from "@/features/shop/cms/preview/cmsPreviewToken";

/** Jeton d'aperçu de l'onglet courant ; se met à jour quand il est effacé (« Quitter l'aperçu », 403/410). */
export const useCmsPreviewToken = (): string | null =>
  useSyncExternalStore(subscribeCmsPreviewToken, getCmsPreviewToken, () => null);
